import e, { useState as u } from "react";
import { StepperWithLabel as _ } from "./index262.mjs";
import { ExtraDescription as d } from "./index263.mjs";
import { MAX_EXTRA_AMOUNT as E } from "./index264.mjs";
import f from "./index265.mjs";
import { ExtraHeader as A } from "./index266.mjs";
const y = e.memo(
  ({
    extra: t,
    index: m,
    setExtras: r,
    currency: a,
    onAdd: i,
    onRemove: n,
    initialAmount: s = 0
  }) => {
    const [c, l] = u(s), p = (o) => {
      l(o), r({
        ...t,
        amount: o
      });
    };
    return /* @__PURE__ */ e.createElement(
      "li",
      {
        className: f.extra,
        key: t.id,
        "data-testid": `extra-item-${m}`
      },
      /* @__PURE__ */ e.createElement(
        _,
        {
          amount: c,
          onAdd: i,
          onRemove: n,
          setAmount: p,
          limit: t.manually_select_amount ? t.maximum_amount_per_booking || E : 1
        },
        /* @__PURE__ */ e.createElement(
          A,
          {
            index: m,
            name: t.name,
            totalPrice: t.total_price,
            currency: a
          }
        )
      ),
      /* @__PURE__ */ e.createElement(d, { description: t.description })
    );
  },
  (t, m) => t.extra.id === m.extra.id
);
y.displayName = "ExtraUnit";
export {
  y as ExtraUnit
};
